const config = {
  apiGateway: {
    REGION: 'ap-southeast-1',
    PHY_LOCATION_APIGATEWAY_URL: 'https://q68y52dee6.execute-api.ap-southeast-1.amazonaws.com/prod',
    INTERNAL_PHY_LOCATION_APIGATEWAY_URL: 'https://q8mh2hsm2d.execute-api.ap-southeast-1.amazonaws.com/prod',
    COMPANY_APIGATEWAY_URL: 'https://458zs88src.execute-api.ap-southeast-1.amazonaws.com/prod',
  },
  reactApp: {
    VERSION: 'taxonomy-physical-location-1.16.5',
    HOSTNAME: 'https://locations.oceanagold.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.oceanagold.forwoodsafety.com',
    WEBSOCKET: 'wss://rtlm1yf763.execute-api.ap-southeast-1.amazonaws.com/prod'
  },
};

export default config;